import {monitoringTableSort} from './monitoring-products-tool.js';
import './amp-lazy-leaflets.js';

monitoringTableSort();
